enum UserRole{
  USER= 'USER',
  ADMIN= 'ADMIN',
  SUPERADMIN= 'SUPERADMIN'
};

export default UserRole;